import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { fmt, apiImageUrl } from "../../lib/shopApi";

export const ProductCard = ({ product, index = 0 }) => {
  const soldOut = product.status === "sold_out" || product.total_stock <= 0;
  const fromPrice = product.sizes?.length
    ? Math.min(...product.sizes.map((s) => s.price_cents))
    : product.sale_price_cents || product.price_cents;

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: index * 0.06 }}
    >
      <Link
        to={`/shop/product/${product.slug}`}
        data-testid={`product-card-${product.slug}`}
        className="group block bg-[#232323] border border-[#C9A24B]/10 rounded-2xl overflow-hidden hover:border-[#C9A24B]/50 hover:-translate-y-1.5 transition-all duration-500 hover:shadow-[0_20px_50px_rgba(201,162,75,0.12)]"
      >
        <div className="relative aspect-square overflow-hidden bg-[#181818]">
          <img
            src={apiImageUrl(product.images?.[0])}
            alt={`${product.name} - Johannesburg locs product`}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[1.1s] ease-out group-hover:scale-105"
          />
          {soldOut && (
            <span className="absolute top-4 left-4 bg-[#1C1C1C]/90 border border-[#C9A24B]/40 text-[#C9A24B] text-[10px] uppercase tracking-widest px-3 py-1.5 rounded-full">
              Sold Out
            </span>
          )}
          {product.sale_price_cents && !soldOut && (
            <span className="absolute top-4 left-4 bg-[#C9A24B] text-[#1C1C1C] text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 rounded-full">
              Sale
            </span>
          )}
        </div>
        <div className="p-5">
          <p className="text-[#C9A24B]/70 text-[10px] uppercase tracking-[0.25em] mb-1.5">{product.category}</p>
          <h3 className="font-serif text-lg leading-snug mb-3 group-hover:text-[#C9A24B] transition-colors duration-300">
            {product.name}
          </h3>
          <div className="flex items-center gap-2">
            {product.sale_price_cents ? (
              <>
                <span className="text-[#C9A24B] font-semibold">{fmt(product.sale_price_cents)}</span>
                <span className="text-[#F5EFE3]/40 text-sm line-through">{fmt(product.price_cents)}</span>
              </>
            ) : (
              <span className="text-[#C9A24B] font-semibold">
                {product.sizes?.length > 1 ? `From ${fmt(fromPrice)}` : fmt(fromPrice)}
              </span>
            )}
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
